import { useTranslation } from 'react-i18next'

import { CredentialField, CredentialsCardProps, CredentialsFormCard } from './credentials-form-card'
import { useDormakabaCredentials, useSaveDormakabaCredentials } from './provider-connections'

export const DormakabaCard = ({ buildingId, ...props }: CredentialsCardProps) => {
  const { t } = useTranslation(['organisation'])
  const { configured, host, isLoading, scope } = useDormakabaCredentials(buildingId)
  const { isPending, mutateAsync: save } = useSaveDormakabaCredentials()

  const fields: CredentialField[] = [
    {
      error: t('organisation:places.integrations.dormakaba.errors.host'),
      label: t('organisation:places.integrations.dormakaba.fields.host.label'),
      name: 'host',
      placeholder: t('organisation:places.integrations.dormakaba.fields.host.placeholder'),
    },
    {
      error: t('organisation:places.integrations.dormakaba.errors.username'),
      label: t('organisation:places.integrations.dormakaba.fields.username.label'),
      name: 'username',
      placeholder: t('organisation:places.integrations.dormakaba.fields.username.placeholder'),
    },
    {
      error: t('organisation:places.integrations.dormakaba.errors.password'),
      label: t('organisation:places.integrations.dormakaba.fields.password.label'),
      name: 'password',
      placeholder: t('organisation:places.integrations.dormakaba.fields.password.placeholder'),
      secret: true,
    },
    {
      error: t('organisation:places.integrations.dormakaba.errors.clientId'),
      label: t('organisation:places.integrations.dormakaba.fields.clientId.label'),
      name: 'clientId',
      placeholder: t('organisation:places.integrations.dormakaba.fields.clientId.placeholder'),
    },
    {
      error: t('organisation:places.integrations.dormakaba.errors.clientSecret'),
      label: t('organisation:places.integrations.dormakaba.fields.clientSecret.label'),
      name: 'clientSecret',
      placeholder: t('organisation:places.integrations.dormakaba.fields.clientSecret.placeholder'),
      secret: true,
    },
    {
      error: t('organisation:places.integrations.dormakaba.errors.scope'),
      label: t('organisation:places.integrations.dormakaba.fields.scope.label'),
      name: 'scope',
      placeholder: t('organisation:places.integrations.dormakaba.fields.scope.placeholder'),
    },
  ]

  return (
    <CredentialsFormCard
      {...props}
      configured={configured}
      fields={fields}
      isLoading={isLoading}
      isSaving={isPending}
      savedValues={{ host, scope }}
      onSave={(values) =>
        save({
          buildingId,
          clientId: values.clientId,
          clientSecret: values.clientSecret,
          host: values.host,
          password: values.password,
          scope: values.scope,
          username: values.username,
        })
      }
    />
  )
}
